import React, { useEffect, useState } from 'react';
import { Table, Typography, Spin, Alert, Tag, Select } from 'antd';

const { Title } = Typography;
const { Option } = Select;

const UserLogs = () => {
  const [logs, setLogs] = useState([]);
  const [filteredLogs, setFilteredLogs] = useState([]);
  const [roleFilter, setRoleFilter] = useState("all");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchLogs = async () => {
      try {
        const res = await fetch("http://localhost:5000/api/user_logs");
        const data = await res.json();
        setLogs(data);
        setFilteredLogs(data); // initial display
      } catch (err) {
        setError("Failed to fetch logs");
      } finally {
        setLoading(false);
      }
    };
    fetchLogs();
  }, []);

  // 🎯 Filter by role
  const handleRoleChange = (value) => {
    setRoleFilter(value);
    if (value === "all") {
      setFilteredLogs(logs);
    } else {
      setFilteredLogs(logs.filter((log) => log.role === value));
    }
  };

  const getRoleTag = (role) => {
    switch (role) {
      case "admin":
        return <Tag color="red">👩‍💼 Admin</Tag>;
      case "photographer":
        return <Tag color="blue">📸 Photographer</Tag>;
      case "guest":
        return <Tag color="green">🙋‍♂️ Guest</Tag>;
      default:
        return <Tag>{role}</Tag>;
    }
  };

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Role",
      dataIndex: "role",
      key: "role",
      render: (role) => getRoleTag(role),
    },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
    },
    {
      title: "Event ID",
      dataIndex: "event_name",
      key: "event_name",
    },
    {
      title: "Details",
      dataIndex: "details",
      key: "details",
    },
    {
      title: "Timestamp",
      dataIndex: "timestamp",
      key: "timestamp",
      render: (text) => new Date(text).toLocaleString(),
    },
  ];

  if (loading) return <Spin tip="Loading logs..." />;
  if (error) return <Alert message={error} type="error" />;

  return (
    <div style={{ padding: "20px" }}>
      <Title level={1}>Activity Logs</Title>

      <div style={{ marginBottom: "16px" }}>
        <label style={{ marginRight: "10px" }}>Filter by Role:</label>
        <Select value={roleFilter} onChange={handleRoleChange} style={{ width: 200 }}>
          <Option value="all">Show All</Option>
          <Option value="admin">Admin 👩‍💼</Option>
          <Option value="photographer">Photographer 📸</Option>
          <Option value="guest">Guest 🙋‍♂️</Option>
        </Select>
      </div>

      <Table
        dataSource={filteredLogs}
        columns={columns}
        rowKey={(record, i) => i}
        bordered
      />
    </div>
  );
};

export default UserLogs;
